import { CheckBox, Spacer } from "@components/atoms";
import React, { memo, useEffect, useState } from "react";
import styled from "styled-components/native";
import styledWeb from "styled-components";
import { Platform, Pressable } from "react-native";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon from "@components/icons/VDBIcon";
import { IconsVariant } from "@components/icons/VDBIcon";
import { useTheme } from "styled-components/native";
import { SearchResultTabletProps } from "./types";
import {
  getProductListViewData,
  preventLeftClickWeb,
} from "@scenes/searchResults/Utils";
import {
  useDisplayImage,
  useSortedTabletListData,
} from "../../../hooks/useSortCustomData";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { VDBIcons } from "@utils/VDBIcons";
import * as styledDiv from "styled-components";
import { useSelector } from "react-redux";
import { getProductThemeFromType } from "@components/common/Header/utils";
import TabletListCellItem from "./TabletListCellItem";
import { useAnimation } from "../../../contexts/AnimationContext";
import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { DeviceEventEmitter } from "react-native";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { createItemDetailLink } from "@utils/product/searchResultsNavigation";
import { isLinkedPair } from "@utils/product/productValidators";
import Animated, { useAnimatedStyle } from "react-native-reanimated";
import { useHorizontalOffset } from "@scenes/searchResults/components/HorizontalScrollContext";
import { calculateEmptyWidth } from "./utils";
import { useHorizontalScrollMultiplier } from "@scenes/searchResults/components/HorizontalScrollMultiplierContext";
import { TRAILING_SPACER_WIDTH } from "@scenes/searchResults/components/HorizontalScrollWrapper";
import { DefaultTheme } from "styled-components/native";
import { css } from "styled-components/native";
const SearchResultTabletListItem = ({
  mItem,
  index,
  checkBoxSelection,
  ismItemChecked,
  productType,
  handleItemClick,
  favoriteClickedFunction,
  removeFavorite,
  fromBulkList,
  customizeColumnParams,
  userCurrency,
  productPrefix,
  sectionName = SearchFilterTypeEnum.SINGLE_STONES,
  handleLinkClick,
  selectedStoneType,
  testID,
  dataTestId,
}: SearchResultTabletProps) => {
  const theme = useTheme();
  const { addRouteToHistory } = useNavigationHistory();
  const userInfo = useUserInfo();
  const userPriceMode = userInfo.user.price_mode;
  const horizontalMultiplier = useHorizontalScrollMultiplier();
  const isCustomApp = useSelector((state) => state?.appState?.isCustomApp);
  // Get horizontal offset from context for transform-based scrolling (large screen only)
  const xOffset = useHorizontalOffset();
  const horizontalAnimatedStyle = useAnimatedStyle(() => ({
    // Only apply transform on large screen; tablet uses native ScrollView
    transform: [
      { translateX: theme.isLargeScreen && xOffset ? -xOffset.value : 0 },
    ],
  }));
  const { triggerAnimation } = useAnimation();
  const showFavoritesAnimation = useSelector(
    (state: any) =>
      state.globalData?.app_settings?.showFavoritesAnimation ?? false
  );
  const [isItemChecked, setIsItemChecked] = useState(
    mItem?.is_selected || ismItemChecked || false
  );
  const [isFavorite, setIsFavorite] = useState(false);
  const { deviceWidth } = useIsFoldable();
  const screenWidth = deviceWidth - 48;
  const productListViewData = getProductListViewData(productType);
  const productTheme = getProductThemeFromType(productType);
  const defaultListDataOptions = useSortedTabletListData(
    productType,
    userPriceMode,
    sectionName,
    fromBulkList,
    false,
    selectedStoneType
  );
  const listDataOptions =
    customizeColumnParams && customizeColumnParams.length > 0
      ? customizeColumnParams
      : productListViewData && productListViewData.length > 0
      ? productListViewData
      : defaultListDataOptions;
  const filteredListDataOptions = listDataOptions.filter((item: any) => {
    if (sectionName === SearchFilterTypeEnum.PAIRS) {
      return item.response_key !== "pair";
    }
    return true;
  });
  const displayImage = useDisplayImage(productType) ?? false;
  const checkStateChanged = () => {
    const newCheckedState = !isItemChecked;
    setIsItemChecked(newCheckedState);
    checkBoxSelection(newCheckedState, mItem, productType);
  };
  useEffect(() => {
    setIsItemChecked(mItem?.is_selected || ismItemChecked || false);
  }, [ismItemChecked, mItem?.is_selected]);
  useEffect(() => {
    if (mItem?.is_favorite !== undefined) {
      setIsFavorite(mItem?.is_favorite);
    }
  }, [mItem?.is_favorite]);

  const isIFrame = userInfo.isIFrame();
  const ItemDetailLink = isIFrame ? OverlayIFrame : OverlayWeb;
  const itemDetailLinkProps =
    !isIFrame && Platform.OS === "web"
      ? {
          href: createItemDetailLink({
            productID: mItem?.id,
            productType,
            priceMode: userInfo.getPriceMode(),
            productPrefix,
          }),
          onClick: preventLeftClickWeb,
        }
      : {};

  const CellItem = (item: any, _index: number) => (
    <TabletListCellItem
      key={_index}
      item={item}
      isCustomApp={isCustomApp}
      mItem={mItem}
      userCurrency={userCurrency}
      userInfo={userInfo}
      _index={_index}
      displayImage={displayImage}
      fromBulkList={fromBulkList}
      handleLinkClick={handleLinkClick}
      sectionName={sectionName}
    />
  );
  return (
    <StyledDiv
      theme={theme}
      isChecked={isItemChecked}
      productType={productTheme}
      isOdd={index ? index % 2 !== 0 : false}
      {...(theme.isLargeScreen ? { width: screenWidth } : {})}
    >
      <Pressable
        onPress={() =>
          handleItemClick(
            mItem,
            productType,
            userInfo.getPriceMode(),
            productPrefix,
            addRouteToHistory
          )
        }
      >
        <Animated.View
          style={[{ flexDirection: "row" }, horizontalAnimatedStyle]}
        >
          <FirstContentMapContainer>
            {!userInfo.isIFrame() && (
              <TableCell
                linkedPair={
                  !!isLinkedPair(mItem) &&
                  sectionName === SearchFilterTypeEnum.PAIRS
                }
                multiplier={horizontalMultiplier}
                {...(theme.isLargeScreen
                  ? {
                      width: calculateEmptyWidth({
                        isTablet: theme.isTablet,
                        showCheckbox: true,
                        showFavorite: true,
                      }),
                    }
                  : {})}
              >
                <CheckBox
                  fillColor={theme["knob-bor"]}
                  checkBoxSize={20}
                  checkedFunction={checkStateChanged}
                  isChecked={isItemChecked}
                  testID={testID + ".checkbox"}
                  dataTestId={dataTestId + ".checkbox"}
                />
                {!removeFavorite && (
                  <>
                    <Spacer
                      size={
                        !theme.isLargeScreen
                          ? SpaceType.Big * horizontalMultiplier
                          : SpaceType.Basic * horizontalMultiplier
                      }
                    />
                    <Pressable
                      style={{ justifyContent: "center" }}
                      testID={testID + ".favorite"}
                      data-testId={dataTestId + ".favorite"}
                      onPress={(event) => {
                        if (!isFavorite && showFavoritesAnimation) {
                          if (
                            Platform.OS === "web" &&
                            theme.isLargeScreen &&
                            event.currentTarget
                          ) {
                            const rect = (
                              event.currentTarget as any
                            ).getBoundingClientRect();
                            const heartPosition = {
                              x: rect.left + rect.width / 2,
                              y: rect.top + rect.height / 2,
                            };
                            triggerAnimation(heartPosition);
                          }
                          DeviceEventEmitter.emit("animateFavoritesTab");
                        }
                        favoriteClickedFunction(isFavorite, mItem);
                      }}
                    >
                      <VDBIcon
                        color={theme[isFavorite ? "error-01" : "extra-01"]}
                        size={20}
                        variant={IconsVariant.VDBCustom}
                        name={isFavorite ? VDBIcons.FAV : VDBIcons.FAV_EMPTY}
                      />
                    </Pressable>
                  </>
                )}
              </TableCell>
            )}
            <ItemDetailLink {...itemDetailLinkProps}>
              {filteredListDataOptions?.map((item, _index) => (
                <React.Fragment key={_index}>
                  {CellItem(item, _index)}
                </React.Fragment>
              ))}
            </ItemDetailLink>
            <TrailingSpacer />
          </FirstContentMapContainer>
        </Animated.View>
      </Pressable>
    </StyledDiv>
  );
};
const FirstContentMapContainer = styled.View`
  flex-direction: row;
`;
const TableCell = styled.View<{
  linkedPair?: boolean;
  multiplier: number;
  width: number;
}>`
  padding-top: ${({ linkedPair }: any) =>
    linkedPair ? "18px" : `${SpaceType.Basic}px`};
  padding-bottom: ${({ linkedPair }: any) =>
    linkedPair ? "18px" : `${SpaceType.Basic}px`};
  padding-left: ${({ multiplier }: any) => SpaceType.Double * multiplier}px;
  padding-right: ${({ multiplier }: any) => SpaceType.Extra * multiplier}px;
  flex-direction: row;
  align-items: space-between;
  ${({
    theme,
    width,
    multiplier,
  }: {
    theme: DefaultTheme;
    width: number;
    multiplier: number;
  }) =>
    theme.isLargeScreen &&
    css`
      width: ${width * multiplier}px;
    `}
`;
const StyledDiv =
  Platform.OS === "web"
    ? styledDiv.default.div<{
        width: number;
        isChecked?: boolean;
        isOdd?: boolean;
        productType: string;
      }>`
      min-width: ${({ width }) => width}px;
      flex-direction: column;
      background-color: ${({ theme, isChecked, isOdd, productType }) => {
        if (isChecked) {
          return theme[`${productType}-03`];
        }
        return isOdd ? theme["core-02"] : theme["core-01"];
      }};
      &:hover {
        background-color: ${({ theme, productType }) =>
          theme[`${productType}-03`]};
      }
    `
    : styled.View<{
        width: number;
        isChecked?: boolean;
        isOdd?: boolean;
        productType: string;
      }>`
        min-width: ${({ width }) => width}px;
        flex-direction: column;
        background-color: ${({ theme, isChecked, isOdd, productType }) => {
          if (isChecked) {
            return theme[`${productType}-03`];
          }
          return isOdd ? theme["core-02"] : theme["core-01"];
        }};
      `;

const PassThrough = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);

const OverlayWeb =
  Platform.OS === "web"
    ? styledWeb("a")`
        text-decoration: none;
        display: flex;
        flex: 1;
      `
    : PassThrough;

const OverlayIFrame =
  Platform.OS === "web"
    ? styled.View`
        flex-direction: row;
        flex: 1;
      `
    : PassThrough;

const TrailingSpacer = styled.View`
  width: ${TRAILING_SPACER_WIDTH}px;
`;

export default memo(SearchResultTabletListItem, (prev, next) => {
  return (
    prev.mItem === next.mItem &&
    prev.checkBoxSelection === next.checkBoxSelection &&
    prev.ismItemChecked === next.ismItemChecked &&
    prev.productType === next.productType &&
    prev.handleItemClick === next.handleItemClick &&
    prev.favoriteClickedFunction === next.favoriteClickedFunction &&
    prev.priceMode === next.priceMode &&
    prev.customizeColumnParams === next.customizeColumnParams &&
    prev.productPrefix === next.productPrefix &&
    prev.userCurrency === next.userCurrency &&
    prev.sectionName === next.sectionName &&
    prev.testID === next.testID &&
    prev.dataTestId === next.dataTestId
  );
});
